import { BlobEditorContext } from './types';

export const initialState: BlobEditorContext = {
  blob: {
    id: '',
    type: 'NOT_SELECTED',
    name: ''
  },
  step: 'NONE',
  isCreator: false,
  isDirty: false
};

export const getMockedBlobEditorInitialState = (mockedState?: Partial<BlobEditorContext>): BlobEditorContext => ({
  isCreator: false,
  isDirty: false,
  step: 'ADD_DESCRIPTION',
  blob: {
    id: 'testBlobId',
    type: 'VIDEO',
    name: 'Test blob'
  },
  ...mockedState
});
